import Button from "../UniversalComponents/DefaultButton";
import React, { useState, useEffect } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import crossIcon from "../../assets/images/CrossInActive.svg";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import FieldElements from "../UniversalComponents/FieldElements";
import { useAddValueInManageListMutation } from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import useRequireAuth from "../../utils/useRequireAuth";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";

const AddListDrawer = ({
  open,
  onClose,
  editListData,
  setEditListData,
  headersResponseData,
  tableData,
  handleRowClick,
}) => {
  console.log(editListData, "editListDataaddlistdrawer");

  const [formData, setFormData] = useState({});
  const { token } = useRequireAuth();
  const dispatch = useDispatch();

  const formatLabel = (text) => {
    return text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  };

  useEffect(() => {
    if (headersResponseData) {
      const initialData = {};
      headersResponseData.forEach((field) => {
        if (field.type === "text" || field.type === "number") {
          const value = editListData?.[field.value] || "";
          initialData[field.id] = value;
        }
      });
      setFormData(initialData);
    }
  }, [headersResponseData, editListData]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [
    postNewList,
    { data: addListResponseData, isError: addListError, isSuccess: addListSuccess, isLoading: addListLoading },
  ] = useAddValueInManageListMutation();

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const tableId = tableData?.id;
  //   const payload = {
  //     row_id: editListData?.row_id,
  //     data: {},
  //   };

  //   Object.entries(formData).forEach(([fieldId, value]) => {
  //     payload.data[fieldId] = { value };
  //   });

  //   postNewList({ token, payload, tableId });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    const tableId = tableData?.id;

    const payload = {
      data: {},
    };

    // Only include row_id if it's edit mode
    if (editListData?.row_id) {
      payload.row_id = editListData.row_id;
    }

    // Restructure formData to match the required nested value format
    Object.entries(formData).forEach(([fieldId, value]) => {
      payload.data[fieldId] = {
        value: {
          value: value,
          // color: "#ffff" // Uncomment in the future
        },
      };
    });

    postNewList({ token, payload, tableId });
  };

  useEffect(() => {
    if (addListLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (addListSuccess) {
      dispatch(
        pushAlert({
          message: addListResponseData?.message,
          type: "success",
          visible: true,
        })
      );
      {
        console.log(addListResponseData?.status, "addListResponseData?.status");
      }
      if (addListResponseData?.status) {
        onClose();
        handleRowClick(tableData);
      }
    }
    // catch block
    if (addListError) {
      dispatch(pushAlert({ message: addListResponseData?.message, type: "danger", visible: true }));
    }
  }, [addListSuccess, addListError, addListLoading]);

  const isFormDisabled = formData?.status;

  const getProjectFields = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField) => (
          <div className={`col-span-${eachField.colspan ?? "1"}`}>
            {!eachField?.noLabel && (
              <label htmlFor={eachField?.label} className="block mb-1 text-lg text-434852">
                <span className={`text-sm ${isFormDisabled ? "text-6B6B6B" : "text-434852"}`}>{eachField?.label}</span>
                {eachField?.isMandatory && <span className="text-red-700"> *</span>}
              </label>
            )}
            <div className="flex items-center">
              {
                <FieldElements
                  id={eachField?.id}
                  name={eachField?.id}
                  label={eachField?.label}
                  value={formData[eachField?.id] || ""}
                  displayValueKey={eachField?.displayValueKey}
                  onChange={handleFieldChange}
                  disabled={eachField?.disabled}
                  isFormDisabled={isFormDisabled}
                  // defaultOptions={selectionList}
                  type={eachField?.type}
                  noKeyboardNavigation={eachField?.noKeyboardNavigation}
                  childrenKey={eachField?.childrenKey}
                  formData={formData}
                  // taskid={taskid}
                  defaultOptions={eachField?.defaultOptions}
                  dynamicOptions={eachField?.dynamicOptions}
                  apiCall={eachField?.apiCall}
                  addButton={eachField?.addButton}
                  addButtonLabel={eachField?.addButtonLabel}
                  addButtonAction={eachField?.addButtonAction}
                  isLoading={eachField?.isLoading}
                  useFetchHook={eachField?.useFetchHook}
                  hookPayload={eachField?.hookPayload}
                  noDisabled={eachField?.noDisabled}
                  isNegativeValue
                />
              }
              {/* {getFieldElements(
           { id:eachField?.id,name:eachField?.name,label:eachField?.label,onChange:handleInputChange,disabled:eachField?.disabled,isFormDisabled:eachField?.isFormDisabled,selectionList,type:eachField?.type}
         )} */}
            </div>
          </div>
        ))}
    </>
  );

  return (
    <CustomDrawer open={open} onClose={onClose} anchor="right">
      <div className="relative mt-18 bg-white h-full w-full flex flex-col font-popns rounded-md overflow-hidden no-scrollbar">
        {/* Header */}
        <div className="mx-6 flex items-center justify-between py-4 md:py-3 border-BECBD3 rounded-t">
          <h3 className="text-16 text-1D4469 font-500">{editListData?.row_id ? "Edit List" : "Add List"}</h3>
          <button
            onClick={onClose}
            type="button"
            className="text-454545 hover:text-[#1D4469] text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
          >
            <img src={crossIcon} alt="Close" className="hover:bg-[#EBF2F6] w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form className="w-full grow min-h-0 pt-3 border-t flex flex-col justify-between" onSubmit={handleSubmit}>
          <div className="grow min-h-0 overflow-y-scroll thinscrollbar">
            <div className="flex flex-col gap-y-2 px-6">
              {/* Fields */}
              {getProjectFields({ projectFields: headersResponseData })}
            </div>
          </div>

          <div className="flex gap-3 py-2 pe-5 justify-end w-full">
            <Button variant={"secondary"} type={"button"} onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {editListData?.row_id ? "Update" : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </CustomDrawer>
  );
};

export default AddListDrawer;
